import { Component, inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';

// PrimeNG Imports
import { DynamicDialogModule, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { ChipsModule } from 'primeng/chips';
import { DatePickerModule } from 'primeng/datepicker';
import { TextareaModule } from 'primeng/textarea';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-upload-dialog-document',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DynamicDialogModule,
    ToastModule,
    ButtonModule,
    InputTextModule,
    ChipsModule,
    DatePickerModule,
    TextareaModule,
    ToggleSwitchModule,
  ],
  templateUrl: './upload-dialog-document.component.html',
  styleUrl: './upload-dialog-document.component.scss',
  standalone: true,
})
export class UploadDialogDocumentComponent implements OnInit {
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);
  fb = inject(FormBuilder);
  messageService = inject(MessageService);
  cdr = inject(ChangeDetectorRef);

  metaDataFormGroup = this.fb.group({
    document_id: [null, Validators.required],
    category: [null, Validators.required],
    description: [null, Validators.required],
    keywords: [<string[]>[], Validators.required],
    latest: [false, Validators.required],
    link: [null, Validators.required],
    year_of_publication: [null, Validators.required],
    timestamp: [<string | null>null, Validators.required],
  });

  ngOnInit() {
    this.cdr.detectChanges();

    this.metaDataFormGroup.patchValue({
      document_id: this.config.data.name,
      timestamp: new Date().toISOString(),
    });
  }

  saveMetadata() {
    console.log(this.metaDataFormGroup.value);
    if (this.metaDataFormGroup.valid) {
      this.ref.close(this.metaDataFormGroup.value);
    }
  }

  closeDialog() {
    this.ref.close();
  }
}
